import PropertyConstants from './PropertyConstants';

const { PROPERTY_CODES_BY_TYPE, PROPERTY_TYPES } = PropertyConstants;
const { CONDO, HOUSE, TOWNHOUSE } = PROPERTY_TYPES;

const DEFAULT_FILTER_VALUE = 'all';

const BEDROOMS_API_CONSTANTS = {
  [DEFAULT_FILTER_VALUE]: null,
  0: '0',
  1: '1',
  2: '2',
  3: '3',
  4: '4+',
};

const PROPERTY_TYPE_API_CONSTANTS = {
  [DEFAULT_FILTER_VALUE]: null,
  [PROPERTY_CODES_BY_TYPE[HOUSE]]: PROPERTY_CODES_BY_TYPE[HOUSE],
  [PROPERTY_CODES_BY_TYPE[CONDO]]: PROPERTY_CODES_BY_TYPE[CONDO],
  [PROPERTY_CODES_BY_TYPE[TOWNHOUSE]]: PROPERTY_CODES_BY_TYPE[TOWNHOUSE],
};

const COMPARE_LISTING_HEADING = 'Compare your listing';

const FILTERS_EXPLANATION =
  'Filter Zillow’s active rental listings to show comparison data only for properties similar to yours (also known as “comps”).';

export {
  BEDROOMS_API_CONSTANTS,
  PROPERTY_TYPE_API_CONSTANTS,
  DEFAULT_FILTER_VALUE,
  COMPARE_LISTING_HEADING,
  FILTERS_EXPLANATION,
};
